import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * The brand mark: the glowing cube, cut out of the supplied artwork.
 *
 * Alpha rather than a white plate, which is what lets the same file sit on the pale
 * nav pill, on the near-black footer, and on the admin sidebar. `aria-hidden` because
 * wherever it is used the wordmark beside it is real text — announcing both would read
 * the brand name twice.
 *
 * The wordmark is never part of the image: it stays crisp at any size, recolours for a
 * dark ground, and is selectable and searchable.
 *
 * Lives in its own module rather than inside `PublicLayout` so the admin console can
 * use the identical mark. Two hand-rolled logos is how a console ends up looking like
 * a different product from the site it publishes — which is exactly what the admin's
 * previous gradient-square placeholder did.
 */
export function BrandMark({ className }: { className?: string }): ReactNode {
  return (
    <picture>
      <source srcSet="/logo-mark.webp" type="image/webp" />
      <img
        src="/logo-mark.png"
        alt=""
        aria-hidden="true"
        width={512}
        height={512}
        decoding="async"
        className={cn('block size-11 shrink-0 object-contain', className)}
      />
    </picture>
  );
}
